import { t } from '../../../../modules/infra/i18n';

export const LENGTH_OF_PERIOD_OPTIONS = [
  { value: 1, labelKey: 'commission:length_of_period.daily' },
  { value: 7, labelKey: 'commission:length_of_period.one_week' },
  { value: 14, labelKey: 'commission:length_of_period.two_weeks' },
  { value: 21, labelKey: 'commission:length_of_period.four_weeks' },
];

export const PAYROLL_KINDS = {
  dailyPayroll: 'dailyPayroll',
  commissionSplits: 'commissionSplits',
};

export const PAYROLL_KIND_OPTIONS = [
  { value: PAYROLL_KINDS.commissionSplits, labelKey: 'commission:payroll_kind.auto_tip_and_commission_splits' },
  { value: PAYROLL_KINDS.dailyPayroll, labelKey: 'commission:payroll_kind.auto_tip_only' },
];

const DISCOUNT_PAYOUT = {
  shop: 'shop',
  split: 'split',
};

export const DISCOUNT_PAYOUT_OPTIONS = [
  { value: DISCOUNT_PAYOUT.split, labelKey: 'commission:discount_payout.split_shop_barber' },
  { value: DISCOUNT_PAYOUT.shop, labelKey: 'commission:discount_payout.all_shop' },
];

// Runtime translation functions
export const getLengthOfPeriodOptions = () => 
  LENGTH_OF_PERIOD_OPTIONS.map(option => ({ ...option, label: t(option.labelKey) }));

export const getPayrollKindOptions = () => 
  PAYROLL_KIND_OPTIONS.map(option => ({ ...option, label: t(option.labelKey) }));

export const getDiscountPayoutOptions = () => 
  DISCOUNT_PAYOUT_OPTIONS.map(option => ({ ...option, label: t(option.labelKey) }));
